import GetApp from 'components/getApp/GetApp';

const appRoutes = [
    { path: '', element: <GetApp />, pageTitle: 'Get the App' },
    { path: '*', element: <GetApp />, pageTitle: 'Get the App' },
];

export default appRoutes;
